<template>
    <v-form ref="form" class="form-container" lazy-validation>

        <v-text-field
            v-model="alias"
            label="Alias"
            class="form-field"
            required
        />

        <v-text-field
            v-model="originator"
            label="Originator"
            :rules="[
                v => !!v || 'Field Required',
                v => (v.length >= 3) || 'Maximum 3 characters allowed',
                v => (v.length <= 11) || 'Maximum 11 characters allowed'
            ]"
            class="form-field"
            required
        />
        <create-form-actions needs-padding @cancel="cancel" @next-step="emitNextStep" @reset="reset" />
    </v-form>
</template>

<script>
    import dateTimeUtils from '@/utils/date-time-utils'
    import moment from 'moment'
    import CreateFormActions from '@/components/CreateFormActions.vue'
    import EventBus from '@/event-bus'

    export default {
        components: { CreateFormActions },
        data() {
            return {
                originator: '',
                datetime: null,
                imageUrl: '',
                alias: '',
                modal: false
            }
        },
        created() {
            EventBus.$on('reset-new-campaign-form', () => {
                this.originator = ''
                this.datetime = null
                this.imageUrl = ''
                this.alias = ''
                this.modal = false
            })
            this.alias = 'CM_SMS_' + dateTimeUtils.getHumanizedDate(new Date())
            this.datetime = moment().add(2, 'hours').toDate()
        },
        methods: {
            emitNextStep() {
                if (!this.$refs.form.validate()) { return }
                const campaign = {
                    originator: this.originator,
                    alias: this.alias,
                    params: 5
                }
                this.$store.dispatch('setCurrentRecurringSMSCampaign', campaign)
                this.$emit('next-step')
            },
            cancel() {
                this.$emit('cancel')
            },
            reset() {
                this.$emit('reset')
            },
            getPastDates(date) {
                return dateTimeUtils.getPastDates(date)
            },
            getPastTime(date) {
                return dateTimeUtils.getPastTime(date)
            }
        }
    }
</script>

<style scoped>

.form-container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
}

.form-field {
    width: 100%;
    padding-left: 15px !important;
    padding-right: 15px !important;
}

</style>
